import { useEffect, useState } from "react";
import { motion, AnimatePresence, useIsPresent } from "framer-motion";
import { Card, Typography, Stack, Paper, Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../store/hooks/store.hooks";
import { RootState } from "../../store/rootStore";
import "./topWins.css";
import topWins from "../../assets/icons/topWins.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const TopWins = () => {
  const wins = useAppSelector((state: RootState) => state.slots.bigWins);
  const { t } = useTranslation();
  const isPresent = useIsPresent();
  return (
    <>
      {wins.length > 0 && (
        <Card
          sx={{
            // maxWidth: "100%",
            mx: "auto",
            boxShadow: "none",
            backgroundImage: "none",
            color: "var(--primary-text-color)",
          }}
        >
          <Typography className="top_wins-section__heading">
            <img src={topWins} alt="TopWins" />
            {t("main.topwins_section.label")}
          </Typography>
          <AnimatePresence>
            <Stack spacing={1}>
              {wins.map((win, index) => (
                <motion.div
                  key={win.id}
                  style={{ position: isPresent ? "static" : "absolute" }}
                  initial={{ opacity: 0, scale: 1 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{
                    opacity: 0,
                    scale: 0,
                  }}
                  transition={{
                    type: "spring",
                    stiffness: 900,
                    damping: 40,
                  }}
                  layout
                >
                  <Paper
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4, 1fr)",
                      gridTemplateRows: "repeat(2, 1fr)",
                      padding: "15px",
                      backgroundImage: "none",
                      bgcolor: "var(--primary-background-color)",
                      borderRadius: "var(--primary-border-radius)",
                    }}
                  >
                    <Typography
                      sx={{
                        textAlign: "left",
                        gridArea: {
                          xs: "2 / 1 / 3 / 3",
                          sm: "1 / 1 / 3 / 2",
                        },
                      }}
                    >
                      {win.userId}
                    </Typography>
                    <Typography
                      component={Link}
                      to={`/slots/${win.game.code}`}
                      sx={{
                        textAlign: "left",
                        textDecoration: "none",
                        color: "inherit !important",
                        cursor: "pointer",
                        "&:hover": { fontWeight: "bold" },
                        gridArea: {
                          xs: "1 / 1 / 2 / 3",
                          sm: "1 / 2 / 3 / 3",
                        },
                      }}
                    >
                      {win.game.name}
                    </Typography>
                    <Typography
                      sx={{
                        textAlign: { sm: "right", xs: "left" },
                        gridArea: {
                          xs: "1 / 3 / 3 / 4",
                          sm: "1 / 3 / 3 / 4",
                        },
                        alignSelf: {
                          xs: "center",
                          sm: "baseline",
                        },
                      }}
                    >
                      x{win.multiplier}
                    </Typography>
                    <Typography
                      sx={{
                        textAlign: "right",
                        gridArea: {
                          xs: "1 / 4 / 3 / 5",
                          sm: "1 / 4 / 3 / 5",
                        },
                        alignSelf: {
                          xs: "center",
                          sm: "baseline",
                        },
                      }}
                      fontWeight="bold"
                    >
                      {`${parseFloat(win.result)
                        .toLocaleString("ru-RU", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                        .replace(",", ".")} ${win.currency}`}
                    </Typography>
                  </Paper>
                </motion.div>
              ))}
            </Stack>
          </AnimatePresence>
        </Card>
      )}
    </>
  );
};

export default TopWins;
